import { useEffect, useState } from 'react'
import { useAppDispatch } from 'store'
import { useIsLogin } from 'store/account/hooks'
import {
  useCurrentSymbol,
  useMarketTradeType,
  useTicker,
} from 'store/market/hooks'
import { TradeType } from 'store/market/types'
import { useDocumentTitle, useEffectOnce } from 'usehooks-ts'
import { toGrouping } from 'utils/number'
import { getChainsActions } from './actions/chainsActions'
import { getNotificationAction } from './actions/notificationActions'

export default function Updater(): null {
  const dispatch = useAppDispatch()

  useEffectOnce(() => {
    dispatch(getChainsActions())
  })

  const tradeType = useMarketTradeType()
  const currentSymbol = useCurrentSymbol()
  const defaultDocumentTitle = `ZKEX: Multi-chain order book DEX, secured with zero-knowledge proofs`
  const [documentTitle, setDocumentTitle] = useState(defaultDocumentTitle)
  const { close = 0 } = useTicker(currentSymbol?.name || '') ?? {}
  useDocumentTitle(documentTitle)
  useEffect(() => {
    if (currentSymbol?.name) {
      const symbol = `${currentSymbol.baseCurrency}-${currentSymbol.quoteCurrency}`
      setDocumentTitle(
        `${toGrouping(close)} | ${symbol} | ZKEX ${
          tradeType === TradeType.Spot
            ? 'Spot'
            : tradeType === TradeType.Perp
            ? 'Perp'
            : ''
        }`
      )
    } else {
      setDocumentTitle(defaultDocumentTitle)
    }
  }, [currentSymbol?.name, close])

  const isLogin = useIsLogin()
  useEffect(() => {
    if (!isLogin) return
    dispatch(getNotificationAction())
  }, [isLogin])

  return null
}
